import React from 'react';
import { Grid } from '@material-ui/core';
import { Button } from '../index';

const styles = (actionButton, selectedData, isReversed) => {
  let background = actionButton?.update && selectedData?.length === 0 ? '#00000061' : '#6200EE';
  if (isReversed) background = 'white';
  return {
    button: {
      background: background,
      lineHeight: '16px',
      fontWeight: '500',
      marginTop: '15px',
      fontFamily: 'canalfont-regular',
    },
  };
};

function Action(props) {
  const { actionButton, selectedData } = props;
  const isReversed = actionButton?.type === 'reversed';
  const classes = styles(actionButton, selectedData, isReversed);
  const reversedColor = actionButton?.update && selectedData?.length === 0 ? 'gray' : '#6200EE';
  return (
    <Grid item xs={actionButton.space || 4}>
      <Button
        variant={isReversed ? 'text' : ''}
        text={actionButton.title}
        style={classes.button}
        textColor={isReversed ? reversedColor : 'white'}
        onClick={() => actionButton?.onClick(selectedData)}
        startIcon={actionButton?.icon()}
        disabled={actionButton?.update && selectedData?.length === 0}
      />
    </Grid>
  );
}

export default Action;
